import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_IMPORT_RUNS } from '@/lib/constants/api'
import { UPLOAD_SOURCE } from '@/lib/constants/imports'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const importRuns = {
  namespaced: true,
  state: buildInitialState({
    runList: [],
    totalRecords: 0,
    sourceOptions: [{ text: 'Upload', value: UPLOAD_SOURCE }]
  }),
  getters: {
    getField
  },
  actions: {
    getRunsWithFilters ({ dispatch, rootGetters }, paginationParams = {}) {
      return dispatch('getRuns', {
        ...rootGetters['importRunFilters/getSearchObject'],
        ...paginationParams
      })
    },
    getRuns ({ commit, dispatch }, filters = {}) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Loading imports, please wait...' })

      return api.doGet({ path: PATH_IMPORT_RUNS, parameters: filters })
        .then(json => json.data)
        .then(paginatedResult => {
          commit('updateStatus', { status: COMPLETE })
          commit('setRuns', paginatedResult)
          return paginatedResult
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to load imports')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  },
  mutations: {
    updateStatus,
    updateField,
    setRuns (state, { result, totalRecords }) {
      const runs = Array.isArray(result) ? result : []
      state.runList = runs
      state.totalRecords = totalRecords || 0

      // The API has no endpoint that enumerates VMS integrations, so the source filter's
      // vendor options are accumulated from the runs seen so far. Options are only ever added,
      // never removed, so a vendor stays selectable after a filtered load drops it from the list.
      runs.forEach(run => {
        if (!run.vmsIntegrationId || !run.vmsIntegrationName) return
        const value = String(run.vmsIntegrationId)
        if (state.sourceOptions.some(option => option.value === value)) return
        state.sourceOptions.push({ text: run.vmsIntegrationName, value })
      })
    }
  }
}

export default importRuns
